import angular from 'angular';
import contextProvider from './context.provider';
import durationService from './duration.service';
import activityLogService from './activity-log.service';
import throttleService from './throttle.service';
import timingStrategyService from './timing-strategy.service';
import avatarService from './avatar.service';
import configuration from './configuration';
import projectSelectorService from "./project-selector.service";


const services = angular.module('ttb.services', [
  contextProvider,
  durationService,
  activityLogService,
  throttleService,
  timingStrategyService,
  avatarService,
  configuration,
  projectSelectorService,
])
  .name;

export default services;



// WEBPACK FOOTER //
// ../services/index.js